import React from "react";
import {Redirect, useLocation} from "react-router-dom";
import PageContainer from 'publish/layout/PageContainer';
import logo from 'assets/img/logo/logo_login.svg';
import character from 'assets/img/char/char_login.svg';
import Button from 'components/buttons/';
import UIInput from 'components/input/input';
import UIInputPW from "components/input/inputPW";
import userStore from "common/user/store/UserStore";
import UIUtil from "utils/UIUtils";
import StringUtil from "utils/StringUtil";
import menuStore from "common/menu/store/MenuStore";
import ValidationUtil from "common/validation/util/ValidationUtil";
import userRepository from "common/user/repository/UserRepository";
import message from "common/message/source/MessageSource";

function ContentsContainer() {
    const [username, setUsername] = React.useState<string>("");
    const [password, setPassword] = React.useState<string>("");
    const [errorCode, setErrorCode] = React.useState<string>("");
    const [redirectUrl, setRedirectUrl] = React.useState<string>();
    const [onCapsLock, setOnCapsLock] = React.useState(false);
    const loginForm = React.useRef<HTMLFormElement>(null);
    const location = useLocation();

    const formId = "loginForm";

    let isSubmit = false;
    const handleSubmit = async (event: React.SyntheticEvent<HTMLElement>) => {
        event.preventDefault();
        if(ValidationUtil.checkAll()) return;

        if (!isSubmit) {
            isSubmit = true;
            const result = await userStore.login(loginForm.current as HTMLFormElement);
            isSubmit = false;
            if (!result.result) {
                setErrorCode(result.code || "");
                if (result.code !== 'LOGIN9003'
                    && result.code !== 'LOGIN9004'
                    && result.code !== 'LOGIN9005'
                    && result.code !== 'LOGIN9006'
                    && result.code !== 'LOGIN9007'
                ) {
                    UIUtil.error(result.message || "", result.code || "").then();
                }
            } else {
                if(userStore.canAdminAccess()) {
                    menuStore.reloadAllList();
                    let nextPage = `/admin`;
                    const searchParams = new URLSearchParams(location.search);
                    if (searchParams.get("url")) {
                        nextPage = searchParams.get("url") || nextPage;
                    }
                    setRedirectUrl(nextPage)
                }
                else {
                    await userRepository.logout();
                    userStore.clearUserStoreNoReplace();
                    await UIUtil.alert(<>접근권한이 없습니다.<br/>(접근권한 문의(02-368-8700) 확인 하셨으면 다시 로그인 부탁드립니다.)</>);
                }
            }
        }
    };

    React.useEffect(()=> {
        userRepository.logout().then();
        userStore.clearUserStoreNoReplace();
    }, [])

    if (StringUtil.isNotEmpty(redirectUrl)) {
        return (
            <Redirect to={redirectUrl}/>
        );
    } else {
        return (
            <PageContainer session={false}>
                <div className="adm-login-wrap">
                    <div className="adm-login">
                        <div className="img-area">
                            <img src={character} alt="" className="char"/>
                        </div>
                        <div className="form-area">
                            <div className="inner">
                                <form className="sign-form" id={formId} name={formId} ref={loginForm}>
                                    <img src={logo} alt="대·중소기업 상생협력기금 종합시스템" className="w190 mb50"/>
                                    <p className="tit">ADMIN LOGIN</p>
                                    <UIInput
                                        className={'tf tf-big w100p'}
                                        value={username}
                                        placeholder={message.get("common.user.message.inputLoginUsername")}
                                        // setFocus={focusName === "username"}
                                        attrs={{
                                            name: "USERNAME",
                                            alt: message.get("common.user.message.inputLoginUsername"),
                                            tabIndex: 1,
                                            autoComplete:"username"
                                        }}
                                        readOnly={false}
                                        // onKeyEnter={() => setFocusName("password")}
                                        valueChanged={(value) => setUsername(value)}
                                        rules={["required"]}
                                    />
                                    <UIInputPW
                                        className={'tf tf-big w100p'}
                                        placeholder={message.get("common.user.message.inputLoginPassword")}
                                        // setFocus={focusName === "password"}
                                        attrs={{
                                            name: "PASSWORD",
                                            alt: message.get("common.user.message.inputLoginPassword"),
                                            tabIndex: 2
                                        }}
                                        readOnly={false}
                                        onKeyEnter={handleSubmit}
                                        valueChanged={(value) => setPassword(value)}
                                        rules={["required"]}
                                        focusClear={true}
                                        isOnCapsLock={result => setOnCapsLock(result)}
                                    />
                                    <UIInput type="hidden"
                                             attrs={{name: "LOGIN_AUTH"}}
                                             value={"admin"}
                                    />
                                    {username.length == 0 && <p className="tx tx-alert">{message.get("common.user.message.inputLoginUsername")}</p>}
                                    {password.length < 8 && <p className="tx tx-alert">{message.get("common.user.message.inputLoginPassword")}</p>}
                                    {onCapsLock && <p className="tx tx-alert">Caps Lock이 켜져있습니다.</p>}
                                    {errorCode == 'LOGIN9003' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.badCredentials`)}</p>}
                                    {errorCode == 'LOGIN9004' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.locked`)}</p>}
                                    {errorCode == 'LOGIN9005' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.disabled`)}</p>}
                                    {errorCode == 'LOGIN9006' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.expired`)}</p>}
                                    {errorCode == 'LOGIN9007' && <p className="tx tx-alert">{message.get(`AbstractUserDetailsAuthenticationProvider.notEmailVerify`)}</p>}
                                    <Button color="pri" size="big" type="submit" onClick={handleSubmit}>{message.get("common.user.message.login", "로그인")}</Button>

                                    {/* <Button color="pri" size="big" type="submit" onClick={updatePassword}>패스워드일괄업데이트(테스트용)</Button> */}
                                </form>
                            </div>

                        </div>
                    </div>
                    <div className="adm-login-footer">
                        Copyright ⓒ 2024 대·중소기업·농어업협력재단. All Rights Reserved.
                    </div>
                </div>

            </PageContainer>
        );
    }
};

export default ContentsContainer;